<template>
	<teleport to="#app">
		<div
			v-if="isVisible"
			class="fixed inset-0 z-[99999] bg-black/90"
			@click.stop
			@mousedown.stop
			@mousemove.stop
			@mouseup.stop
			@touchstart.stop
			@touchmove.stop
			@touchend.stop
			@wheel.stop
			@keydown.stop
		>
			<!-- Modal content -->
			<div class="flex items-center justify-center h-full">
				<Transition
					enter-active-class="transition-all duration-500 ease-out"
					enter-from-class="opacity-0 translate-y-4"
					enter-to-class="opacity-100 translate-y-0"
					leave-active-class="transition-all duration-300 ease-in"
					leave-from-class="opacity-100 translate-y-0"
					leave-to-class="opacity-0 translate-y-4"
					appear
				>
					<div
						v-if="isVisible"
						class="relative flex flex-col items-center max-w-md mx-4 bg-white rounded-xl shadow-lg transform-gpu"
						@click.stop
					>
						<!-- Content -->
						<div class="px-8 py-12 text-center">
							<!-- Icon -->
							<div class="mb-6">
								<div class="w-16 h-16 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl flex items-center justify-center mx-auto border border-blue-100/50 shadow-sm">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="32"
										height="32"
										viewBox="0 0 24 24"
										fill="none"
										stroke="currentColor"
										stroke-width="1.5"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="text-blue-500"
									>
										<path d="M12 2L2 7l10 5 10-5-10-5z"/>
										<path d="M2 17l10 5 10-5"/>
										<path d="M2 12l10 5 10-5"/>
									</svg>
								</div>
							</div>

							<!-- Title -->
							<h2 class="text-xl font-semibold text-gray-900 mb-3">
								{{ getTranslations("We're expanding our content library") }}
							</h2>

							<!-- Message -->
							<p class="text-gray-600 leading-relaxed mb-8">
								{{ getTranslations("This section will be available soon.") }}
							</p>

							<!-- Action Button -->
							<button
								@click="goToCategories"
                            class="mx-auto cursor-pointer rounded-xl bg-blue-500 font-medium bg-opacity-90 py-3 px-4 text-white transition-all duration-300 hover:bg-opacity-100 hover:scale-105 active:scale-95 flex items-center justify-center gap-2"
							>
								{{ getTranslations("View Another Category") }}
							</button>
						</div>
					</div>
				</Transition>
			</div>
		</div>
	</teleport>
</template>

<script src="./EmptyStateModal.js"></script>
